import * as types from "./actionTypes";

export const setCumulativeSubscriberByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_CUMULATIVE_SUBSCRIBER_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setCumulativeSubscriberByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_CUMULATIVE_SUBSCRIBER_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceCumulativeSubscriberYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_CUMULATIVE_SUBSCRIBER_YEARS,
      key,
      payload,
    });
  };
};

export const resetCumulativeSubscriberReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_CUMULATIVE_SUBSCRIBER_REDUCER,
    });
  };
};
